console.log("Knowledge Engine Loaded");

function getProductKnowledge(product) {

    if (!product) {

        return null;

    }

    const variant = product.variants?.[0];

    return {

        id: product.id,

        title: product.title,

        handle: product.handle,

        description: product.body_html,

        price: variant ? variant.price : "",

        comparePrice: variant ? variant.compare_at_price : "",

        tags: product.tags || [],

        productType: product.product_type,

        vendor: product.vendor,

        images: product.images || []

    };

}